import {
  buildSectionContextRequest,
  sectionContextToFormValues,
} from './section-context-transformers';
import type { SectionFormValidated, SectionFormValues } from './section-schemas';
import type { SectionRequest, SectionResponse } from './types/api';

/** Map an API section response onto the form's editable state. */
export function sectionToFormValues(section: SectionResponse): SectionFormValues {
  return sectionContextToFormValues(section);
}

/**
 * Map validated form values onto an API section request payload.
 *
 * `existing` is supplied when editing so we can round-trip the section's
 * current user/role assignments — the form doesn't manage them yet, and the
 * update endpoint would otherwise clear them.
 */
export function formValuesToSectionRequest(
  values: SectionFormValidated,
  parent_id?: string | null,
  sibling_id?: string | null,
  existing?: SectionResponse,
): SectionRequest {
  return {
    ...buildSectionContextRequest(values),
    id: existing?.id,
    company_users: existing?.company_users.map((assignment) => ({
      customer_id: assignment.customer.id,
      role_id: assignment.role.id,
    })),
    parent_id,
    sibling_id,
  };
}
